import React from 'react'
import BurgerIconSVG from "../../../assets/icons/burger-icon.svg"
export const BurgerIcon: React.FC = () => {
  return (
    <img src={BurgerIconSVG} alt="" className="w-[18px] h-[10px]"/>
  )
}
